export const CompetitorsDataConstants = {
  GET_CHART_QUERY_CONFIGS_REQUEST: 'CHART/GET_CHART_QUERY_CONFIGS_REQUEST',
  GET_CHART_QUERY_CONFIGS_SUCCESS: 'CHART/GET_CHART_QUERY_CONFIGS_SUCCESS',
  GET_CHART_QUERY_CONFIGS_ERROR: 'CHART/GET_CHART_QUERY_CONFIGS_ERROR',

  GET_DASHBOARD_QUERIES_REQUEST: 'CHART/GET_DASHBOARD_QUERIES_REQUEST',
  GET_DASHBOARD_QUERIES_SUCCESS: 'CHART/GET_DASHBOARD_QUERIES_SUCCESS',
  GET_DASHBOARD_QUERIES_ERROR: 'CHART/GET_DASHBOARD_QUERIES_ERROR',

  SET_SELECTED_CHART_DEVIATION_SUCCESS: 'CHART/SET_SELECTED_CHART_DEVIATION_SUCCESS',
  RESET_APPLIED_FILTERS: 'CI/RESET_APPLIED_FILTERS',
  APPLIED_FILTERS: 'CI/APPLIED_FILTERS'
};
